import React, { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import WhatWeDo from "../components/WhatWeDo";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import { useLocation } from "react-router-dom";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    // Honour hash navigation from other routes (e.g., /#contact)
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
      }
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <div data-testid="home-page" className="bg-white">
      <Header />
      <main>
        <Hero />
        <WhatWeDo />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
